import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';
import 'bootstrap/dist/css/bootstrap.min.css';

const DashboardLayout = () => {
  return (
    <>
      <Navbar />
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          marginTop: '60px',
          height: 'calc(100vh - 60px)',
          overflow: 'hidden',
        }}
      >
        {/* Sidebar */}
        <div
          style={{
            width: '200px',
            flexShrink: 0,
            overflowY: 'auto',
            scrollbarWidth: 'none',
            background: '#f8f9fa',
            borderRight: '1px solid #dee2e6',
          }}
        >
          <Sidebar />
        </div>

        {/* Main Content Area */}
        <div
          style={{
            flex: 1,
            overflowY: 'auto',
            overflowX: 'hidden',
            background: '#fff',
            padding: '20px',
          }}
        >
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default DashboardLayout;
